import { render, staticRenderFns } from "./NoMargin.vue?vue&type=template&id=4d7211cf&scoped=true&"
import script from "./NoMargin.vue?vue&type=script&lang=js&"
export * from "./NoMargin.vue?vue&type=script&lang=js&"
import style0 from "./NoMargin.vue?vue&type=style&index=0&id=4d7211cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7211cf",
  null
  
)

export default component.exports